<template>
    <div>

        <section class="section-filters bg-offWhite">

            <div>

                <div class="accordion__item">
                    <span class="block border-solid border-b border-greyTan w-full is-active">
                        <div class="container py-6 px-6 mx-auto">
                            <h4 class="h4 text-offBlack pr-10"><span class="text-gold">Filter</span> your lifestyle here</h4>
                        </div>
                    </span>

                    <div class="accordion__content-filters container mx-auto px-6 is-active" data-accordion-content>

                        <div v-if="filtersParagraph" class="w-full md:w-1/2 pt-10" v-html="filtersParagraph"></div>

                        <div class="py-8 lg:py-16 relative" :class="isLoading ? 'opacity-30' : ''">
                            <form>
                                <fieldset class="lg:mb-4">
                                    <p class="font-medium font-geomMed mb-6 lg:text-xl">Style</p>
                                    <ul class="flex flex-wrap">
                                        <li v-for="(style, i) in style.options" :key="i" class="w-1/2 sm:w-1/3 md:w-1/4 xl:w-1/6 mb-4">
                                            <label class="inline-flex items-center">
                                                <input class="form-radio" type="radio" :checked="indexEqualsChosenIndex(i)" @change="setStyle($event, i)">
                                                <span class="ml-2 lg:ml-4 text-sm pr-2 text-offBlack">{{ style }}</span>
                                            </label>
                                        </li>
                                    </ul>
                                </fieldset>
                                <template v-if="style.chosenIndex !== -1">
                                <fieldset class="lg:mb-4">
                                    <p class="font-medium font-geomMed mb-6 lg:text-xl">Bed Layouts
                                        <span class="block text-sm text-offBlack font-geomReg pt-2">Choose an option(s) or skip if you're not sure what you're looking for.</span>
                                    </p>

                                    <ul class="filter-list flex flex-wrap">
                                        <li v-for="layout in filteredBedLayouts" :key="layout.id" class="w-1/2 sm:w-1/3 md:w-1/4 xl:w-1/6 mb-4">
                                            <label class="inline-flex items-center">
                                                <input class="form-checkbox" type="checkbox" :checked="form.bedLayouts.includes(layout.id)" @change="setFormCheckbox(form.bedLayouts, layout.id)">
                                                <span class="ml-2 lg:ml-4 text-sm pr-2 text-offBlack">{{ layout.title }}</span>
                                            </label>
                                        </li>
                                    </ul>
                                </fieldset>

                                <fieldset class="lg:mb-4">
                                    <p class="font-medium font-geomMed mb-6 lg:text-xl">Size
                                        <span class="block text-sm text-offBlack font-geomReg pt-2">Choose an option(s) or skip if you're not sure what you're looking for.</span>
                                    </p>
                                    <ul class="filter-list flex flex-wrap">
                                        <li v-for="dimension in filteredDimensions" :key="dimension.id" class="w-1/2 sm:w-1/3 md:w-1/4 xl:w-1/6 mb-4">
                                            <label class="inline-flex items-center">
                                            <input class="form-checkbox" type="checkbox" :checked="form.dimensions.includes(dimension.id)" @change="setFormCheckbox(form.dimensions, dimension.id)" >
                                                <span class="ml-2 lg:ml-4 text-sm pr-2 text-offBlack">{{ dimension.title }}</span>
                                            </label>
                                        </li>
                                    </ul>
                                </fieldset>

                                <fieldset class="lg:mb-4">
                                    <p class="font-medium font-geomMed mb-6 lg:text-xl">Budget</p>
                                    <ul class="flex flex-wrap">
                                        <li class="w-1/2 sm:w-1/3 md:w-1/4 xl:w-1/6 mb-4">
                                            <label class="inline-flex items-center">
                                                <input class="form-radio" type="radio" :value="[]" v-model="form.budgetRange">
                                                <span class="ml-2 lg:ml-4 text-sm pr-2 text-offBlack">Any</span>
                                            </label>
                                        </li>
                                        <li v-for="range in filteredBudgets" :key="range.id" class="w-1/2 sm:w-1/3 md:w-1/4 xl:w-1/6 mb-4">
                                            <label class="inline-flex items-center">
                                                <input class="form-radio" type="radio" :value="[range.id]" v-model="form.budgetRange">
                                                <span class="ml-2 lg:ml-4 text-sm pr-2 text-offBlack">{{ range.title }}</span>
                                            </label>
                                        </li>
                                    </ul>
                                </fieldset>

                                    <fieldset class="lg:mb-4">
                                        <p class="font-medium font-geomMed mb-6 lg:text-xl">Brands
                                            <span class="block text-sm text-offBlack font-geomReg pt-2">Choose an option(s) or skip if you're not sure what you're looking for.</span>
                                        </p>

                                        <ul class="filter-list flex flex-wrap">
                                            <li v-for="category in categories" :key="category.id" class="w-1/2 sm:w-1/3 md:w-1/4 xl:w-1/6 mb-4">
                                                <label class="inline-flex items-center">
                                                    <input class="form-checkbox" type="checkbox" :checked="form.categories.includes(category.id)" @change="setFormCheckbox(form.categories, category.id)">
                                                    <span class="ml-2 lg:ml-4 text-sm pr-2 text-offBlack">{{ category.brandFilter ? category.brandFilter :category.title }}</span>
                                                </label>
                                            </li>
                                        </ul>
                                    </fieldset>

                                <fieldset>
                                    <div class="mt-20 lg:mt-0 flex justify-end">
                                        <button @click.prevent="resetForm" class="flex items-center mr-12 text-offBlack hover:text-gold justify-center font-geomReg">
                                            Clear All
                                        </button>
                                        <button @click.prevent="toggleForm" class="flex items-center mr-12 text-offBlack hover:text-gold justify-center font-geomReg">
                                            <!-- <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="sync" class="w-6 mr-4 svg-inline--fa fa-sync fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M492 8h-10c-6.627 0-12 5.373-12 12v110.627C426.929 57.261 347.224 8 256 8 123.228 8 14.824 112.338 8.31 243.493 7.971 250.311 13.475 256 20.301 256h10.016c6.353 0 11.646-4.949 11.977-11.293C48.157 132.216 141.097 42 256 42c82.862 0 154.737 47.077 190.289 116H332c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h160c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12zm-.301 248h-10.015c-6.352 0-11.647 4.949-11.977 11.293C463.841 380.158 370.546 470 256 470c-82.608 0-154.672-46.952-190.299-116H180c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H20c-6.627 0-12 5.373-12 12v160c0 6.627 5.373 12 12 12h10c6.627 0 12-5.373 12-12V381.373C85.071 454.739 164.777 504 256 504c132.773 0 241.176-104.338 247.69-235.493.339-6.818-5.165-12.507-11.991-12.507z"></path></svg> -->
                                            Select All
                                        </button>
                                        <button @click.prevent="submitSearch(form)" class="button primary"><span>Search</span></button>
                                    </div>
                                </fieldset>
                                </template>
                            </form>

                            <div v-if="isLoading" class="top-1/2 z-50 absolute h-full w-full m-auto">
                                <div class="text-center mb-6">
                                    <loadingcircle size=10></loadingcircle>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

        </section>


        <transition>
            <results v-if="results" :is-loading="isLoading"></results>
        </transition>

    </div>

</template>


<script>

import Results from './Results'
import State, {
    setBedLayouts,
    setBudgetRanges,
    setCategories,
    setDimensions,
    setLoading,
    setStyle,
    submitSearch
} from './State'
import VueSlider from 'vue-slider-component'
import SmoothScroll from 'smooth-scroll'
import {reactive, toRefs, watch} from 'vue'
import loadingcircle from "../loading-circle";
import {computed} from '@vue/reactivity'

let scroll = new SmoothScroll()

export default {
    components: {
        VueSlider,
        loadingcircle,
        Results
    },

    props: [
        'filtersParagraph'
    ],
    
    setup() {
        setBedLayouts()
        setBudgetRanges()
        setDimensions()
        setCategories()

        const isLoading = computed(() => State.isLoading)

        const form = reactive({
            categories: [],
            bedLayouts: [],
            dimensions: [],
            budgetRange: [],
            [window.csrfTokenName]: window.csrfTokenValue
        })

        const filteredBudgets = computed(() => {
            if (Array.isArray(State.budgetRanges)){
                if (State.style.chosenIndex === 1) {
                    return State.budgetRanges.filter(x => !x.vehicleType)
                } else if (State.style.chosenIndex === 0) {
                    return State.budgetRanges.filter(x => x.vehicleType)
                }
            } else {
                return []
            }
        })

        const filteredDimensions = computed(() => {
            if (Array.isArray(State.dimensions)){
                return State.dimensions.filter(x => x.availability === State.style.chosenIndex || x.availability === "both")
            } else {
                return []
            }
        })

         const filteredBedLayouts = computed(() => {
             if (Array.isArray(State.bedLayouts)){
                 return State.bedLayouts.filter(x => x.availability === State.style.chosenIndex || x.availability === "both")
             } else {
                 return []
             }
         })

        function indexEqualsChosenIndex(i) {
            return i === State.style.chosenIndex
        }

        function toggleForm() {
            if (
                form.categories.length === State.categories.length &&
                form.bedLayouts.length === State.bedLayouts.length &&
                form.dimensions.length === State.dimensions.length
            ) return resetForm()
            else
                resetForm()
            form.categories.push(...State.categories.map(x => x.id))
            form.bedLayouts.push(...State.bedLayouts.map(x => x.id))
            form.dimensions.push(...State.dimensions.map(x => x.id))
        }

        function resetForm() {

            form.categories = []
            form.bedLayouts = []
            form.dimensions = []
            form.budgetRange = []
        }

        function setFormCheckbox(option, id) {
            const isArray = typeof id === 'object'
            if (isArray) return addArrayItemsToForm(option, id)
            if (!option.includes(id)) return option.push(id)
            const i = option.indexOf(id)
            option.splice(i, 1)
        }

        function addArrayItemsToForm(option, id) {
            if (option.some(x => id.includes(x))) return id.forEach(x => option.splice(option.indexOf(x), 1))
            id.forEach(x => option.push(x))
        }

        watch(() => State.style.chosenIndex, resetForm)

        return {
            ...toRefs(State),
            form,
            setFormCheckbox,
            resetForm,
            submitSearch,
            setStyle,
            indexEqualsChosenIndex,
            toggleForm,
            isLoading,
            filteredBudgets,
            filteredDimensions,
            filteredBedLayouts
        }
    }
}
</script>

<style scoped>
.v-enter-active {
    transition: opacity 2s ease;
}
.v-leave-active {
    transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
